var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mloyout"},[(_vm.type=='L_R')?_c('div',{staticClass:"L_R",style:({justifyContent:_vm.just})},[_vm._t("default")],2):_vm._e(),(_vm.type=='T_B')?_c('div',{staticClass:"T_B"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }